var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarehouse(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13 0.09375L0 4.40909V17.908H6.09375V8.76739H19.9062V17.908H26V4.40909L13 0.09375Z",
    fill: "#DCDCDC",
    fillOpacity: 0.7
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.61719 17.9062H18.3828V10.2891H7.61719V17.9062ZM13.7617 11.8125H16.8594V13.3359H13.7617V11.8125ZM13.7617 14.8594H16.8594V16.3828H13.7617V14.8594ZM9.14062 11.8125H12.2383V13.3359H9.14062V11.8125ZM9.14062 14.8594H12.2383V16.3828H9.14062V14.8594Z",
    fill: "#DCDCDC",
    fillOpacity: 0.7
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarehouse);
export default __webpack_public_path__ + "static/media/warehouse.526004a0e1aa253f31d0ec2cb3a09b8f.svg";
export { ForwardRef as ReactComponent };